<span *ngIf="!updating && product?.availability && availability" class="tooltip tooltip-left stock-indicator {{ 'availability' + availability.availability.toString() }}"
    [attr.data-tooltip]="availability.text ? availability.text : 'product.availability' + availability.availability.toString()  | translate">
</span>

<div class="stock-indicator-unavailability"
  *ngIf="product?.unavailabilityInfo && availability && product?.unavailabilityInfo.reason == 'Nouveauté à venir'"
  [innerHTML]="product?.unavailabilityInfo.reason" >
</div>

<!-- <div class="stock-indicator-unavailability"
  *ngIf="product?.unavailabilityInfo && product?.unavailabilityInfo.reason == 'Organisationnel'"
  [innerHTML]="product?.unavailabilityInfo.reason" >
</div> -->

